<template>
  <div>
    <BreadcrumbBanner
      :pageTitle="$t('My favorites')"
      :links="[
        { name: $t('Home'), url: '/' },
        { name: $t('My favorites') }
      ]"
    />
    <!--Casino Demo-->
    <div class="casino-demo pb-60 pb-60 mt-4" v-if="games.length > 0">
      <div class="container-fluid">
        <div class="all-games-wrapper">
          <div class="section-wrapper">
            <h4 class="left-title live-text d-flex align-items-center">
              <span class="icon"
                ><img src="@/assets/img/favarites/love.png" alt="badge"
              /></span>
              {{ $t("Favorites Games") }} <span class="text-base text">{{ games.length }}</span>
            </h4>
          </div>
          <div class="row g-3">
            <div v-for="game in games" :key="game.id" class="col-xxl-3 col-xl-4 col-md-4 col-sm-6">
              <GameCard :game="game" />
            </div>
          </div>
        </div>
      </div>
      <div class="more-btn text-center bt" v-if="nextPage != null">
        <a href="javascript:;" class="border-btn" @click="loadMore">
          <span>{{ $t("Load more") }}</span>
        </a>
      </div>
    </div>
    <div class="recent-view" v-else>
      <div class="container-fluid">
        <div class="recent-content">
          <h2>{{ $t('No favarites yet!') }}</h2>
        </div>
      </div>
    </div>
    <!--Casino Demo-->
  </div>
</template>

<script>

import BreadcrumbBanner from "@/components/partials/Breadcumnd.vue";
import { useFavoritesGamesStore } from "@/store/favoritesGames";
import { mapState, mapActions } from "pinia";
import GameCard from "@/components/partials/GameCard.vue";

export default {
  name: "FavoritesPage",
  components: {
    BreadcrumbBanner,
    GameCard,
  },
  computed: {
    ...mapState(useFavoritesGamesStore, ["games", "nextPage"]),
  },
  methods: {
    ...mapActions(useFavoritesGamesStore, ["loadFavoritesGames"]),
    async loadMore() {
      await this.loadFavoritesGames();
    },
  },
  async mounted() {
    this.nextPage = 1;
    await this.loadFavoritesGames();
  },
};
</script>
